export default __webpack_public_path__ + "static/media/dashboard-update-sound-new.c41645d2.wav";